// extracted by mini-css-extract-plugin
export default {"errorMsg":"AlertText_errorMsg__UNXZC","error":"AlertText_error__YinUx","success":"AlertText_success__Fx2vi","warning":"AlertText_warning__EKBSW","info":"AlertText_info__eFG2G"};